import { OrderTypeObject } from '../order-type-object.model';
import { isNullOrUndefined } from 'util';
import { TabObject } from './tab-object.model';

export class ItemObject {

    public url;

    constructor(public crmId: string, public orderId: string, public type: OrderTypeObject, public tab: TabObject) {
        if (isNullOrUndefined(this.type.urlPath)) {
            this.url = null;
        } else {
            this.url = `provision/orders/detail`;
        }
    }

    public static create() {
        return new ItemObject(null, null, OrderTypeObject.UNKNOWN, TabObject.GENERAL_TAB);
    }

    public static createWithTabAndType(crmId: string, orderId: string, tab: string, type: string) {
        return new ItemObject(crmId, orderId, this.getType(type), TabObject.createWithName(tab));
    }

    private static getType(type: string): OrderTypeObject {
        switch (type) {
            case OrderTypeObject.CRM.urlPath:
                return OrderTypeObject.CRM;
            case OrderTypeObject.PRODUCT.urlPath:
                return OrderTypeObject.PRODUCT;
            case OrderTypeObject.CFS.urlPath:
                return OrderTypeObject.CFS;
            case OrderTypeObject.RFS.urlPath:
                return OrderTypeObject.RFS;
            default: return OrderTypeObject.PRODUCT;
        }
    }

    public clone() {
        return new ItemObject(this.crmId, this.orderId, this.type, this.tab);
    }

}